import { UserOutlined } from '@ant-design/icons';
import {
  FormHandler,
  FormItem,
  SubmitButton,
  TextInput,
} from '@framework/form';
import { Trans, useTranslation } from '@framework/i18n';
import { useBreadcrumbItem, useHistory } from '@framework/ui';
import { yup } from '@framework/validation';
import { Card, Divider, Result, Typography } from 'antd';
import qs from 'qs';
import { useState } from 'react';
import styled from 'styled-components';
import { PageLayout } from '../../ui/layout/PageLayout';

const { Text } = Typography;

const SecondaryText = styled(Text)`
  text-align: center;
  display: block;
  line-height: 1.4em;
`;

export interface IUserEmailValidationPageProps {}

export function UserEmailValidationPage(props: IUserEmailValidationPageProps) {
  const { t } = useTranslation();
  const history = useHistory();

  const urlQuery = qs.parse(history.location.search, {
    ignoreQueryPrefix: true,
  });

  const token = urlQuery.token as string | undefined;
  const fullName = urlQuery.fullName as string | undefined;

  useBreadcrumbItem({
    path: history.location.pathname,
    title: t('user.registration.breadcrumb', 'Registrazione Utente'),
  });

  //   const [register, registerState] = useApiMutation(CitizenApi.addEmail, {});
  const [registerState] = useState<any>({});

  /* Messaggio al successo dell'invio che sostituisce il Form */
  if (registerState.response) {
    return (
      <PageLayout>
        <div style={{ paddingTop: '20px', paddingBottom: '50px' }}>
          <Card>
            <Result
              status="success"
              title={t(
                'user.registration.email-validation.response.success.title',
                'Registrazione effettuata con successo!',
              )}
              subTitle={t(
                'user.registration.email-validation.response.success.sub-title-generic',
                'Per attivare l’utente segui le istruzioni che ti abbiamo inviato via email.',
              )}
            />
          </Card>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <div style={{ paddingTop: '20px', paddingBottom: '50px' }}>
        <Card>
          <FormHandler
            schema={yup.object()}
            initialValues={{ token: token! }}
            onSubmit={v => {
              console.log('submitting form with values: ', v);
            }}
          >
            <SecondaryText type="secondary">
              <Trans
                t={t}
                i18nKey="user.registration.email-validation.message"
                fullName={fullName}
              >
                {/* @ts-expect-error viene visto come un errore ma in realtà è solo la sintassi del componente `<Trans />` per la gestione dei testi dinamici */}
                Ciao <strong>{{ fullName }}</strong>, l’autenticazione è andata
                a buon fine. Inserisci la tua eMail per completare il profilo e
                procedere con l’accesso ai servizi online.
              </Trans>
            </SecondaryText>

            <Divider style={{ marginTop: 0 }}>
              {t('user.registration.form.top-title', 'Dati di accesso')}
            </Divider>
            <FormItem label="Email" name="email">
              <TextInput
                prefix={
                  <UserOutlined
                    aria-hidden="true"
                    style={{ color: '#757575' }}
                  />
                }
                name="email"
              />
            </FormItem>

            <SubmitButton pristineMessage={null} icon={null}>
              {t('user.registration.form.submit-button', 'Registrati')}
            </SubmitButton>
          </FormHandler>
        </Card>
      </div>
    </PageLayout>
  );
}
